import { jsx as _jsx } from "react/jsx-runtime";
const CheckIcon = () => {
    return (_jsx("svg", { width: "22", height: "19", viewBox: "0 0 22 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M20.764 0L20.5993 0.173516L8.2397 15.8767L1.23595 10.411L0 12.0594L8.48689 19L21.588 2.25571L22 1.73516C22 1.73516 21.9176 1.6484 21.8352 1.47489C21.6704 1.30137 21.5056 0.954338 21.4232 0.780822L21.0112 0.347032C20.8464 0.173516 20.764 0 20.764 0Z", fill: "currentColor" }) }));
};
export default CheckIcon;
